export default __webpack_public_path__ + "static/media/icn_list_guide_banner_2.9e131fae.svg";